import React from 'react'
import styles from './contact-us-tiles.module.scss';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import {Box} from "@mui/material";
import {TikTokIcon} from "@/ui/tiktok-icon/tiktokIcon";
import YouTubeIcon from '@mui/icons-material/YouTube';
import {socialMediaProfiles, contactDetails} from "@/content";


type ContactUsProps = {
    showSocials?: boolean;
    hidePhone?: boolean;
    hideLabels?: boolean;
}

const ContactUsTiles = ({showSocials = false, hidePhone = true, hideLabels = true}: ContactUsProps) => {

    const {
        contactNumberOne,
        contactNumberTwo,
        contactEmail,
    } = contactDetails;

    const {
        facebookHandle,
        tikTokHandle,
        instaHandle,
        youTubeHandle,
        facebookLink = 'https://www.facebook.com/',
        tikTokLink = 'https://www.tiktok.com/@',
        instaLink = 'https://www.instagram.com/',
        youTubeLink = 'https://www.youtube.com/user'
    } = socialMediaProfiles;

    const socialsBlock = <>
        {facebookHandle && (
            <div className={styles.contactBlock}>
                <div className={styles.contactIcon}>
                    <FacebookIcon/>
                </div>
                {!hideLabels && (
                    <div className={styles.contactHeading}>
                        Facebook
                    </div>
                )}
                <Box className={styles.contactContent} sx={(theme) => ({
                    '&>a': {color: theme.palette.primary.contrastText}
                })}>
                    <a href={`${facebookLink}${facebookHandle}`} target="_blank"
                       rel="nofollow">{facebookHandle}</a>
                </Box>
            </div>
        )}
        {tikTokHandle && (
            <div className={styles.contactBlock}>

                <div className={styles.contactIcon}>
                    <TikTokIcon color='white'/>
                </div>
                {!hideLabels && (
                    <div className={styles.contactHeading}>
                        TikTok
                    </div>
                )}
                <Box className={styles.contactContent} sx={(theme) => ({
                    '&>a': {color: theme.palette.primary.contrastText}
                })}>
                    <a href={`${tikTokLink}${tikTokHandle}`} target="_blank"
                       rel="nofollow">{tikTokHandle}</a>
                </Box>
            </div>
        )}
        {instaHandle && (
            <div className={styles.contactBlock}>
                <div className={styles.contactIcon}>
                    <InstagramIcon/>
                </div>
                {!hideLabels && (
                    <div className={styles.contactHeading}>
                        Instagram
                    </div>
                )}
                <Box className={styles.contactContent} sx={(theme) => ({
                    '&>a': {color: theme.palette.primary.contrastText}
                })}>
                    <a href={`${instaLink}${instaHandle}`} target="_blank"
                       rel="nofollow">{instaHandle}</a>
                </Box>
            </div>
        )}
        {youTubeHandle && (
            <div className={styles.contactBlock}>

                <div className={styles.contactIcon}>
                    <YouTubeIcon/>
                </div>
                {!hideLabels && (
                    <div className={styles.contactHeading}>
                        Youtube
                    </div>
                )}
                <Box className={styles.contactContent} sx={(theme) => ({
                    '&>a': {color: theme.palette.primary.contrastText}
                })}>
                    <a href={`${youTubeLink}/${youTubeHandle}`} target="_blank"
                       rel="nofollow">{youTubeHandle}</a>
                </Box>
            </div>
        )}
    </>


    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'flex-start',
            alignContent: 'flex-start',
            justifyContent: 'space-around'
        }}>
            <Box>
                <div className={styles.contactUsTileContainer}>

                    {!hidePhone && contactNumberOne && (
                        <Box className={styles.contactBlock} sx={(theme) => ({
                            '&>a': {color: theme.palette.text.primary}
                        })}>

                            <div className={styles.contactIcon}>
                                <PhoneAndroidIcon/>
                            </div>
                            {!hideLabels && (
                                <div className={styles.contactHeading}>
                                    Phone
                                </div>
                            )}
                            <Box className={styles.contactContent} sx={(theme) => ({
                                '&>a': {color: theme.palette.text.primary}
                            })}>
                                <a href={`tel:${contactNumberOne}`}>{contactNumberOne}</a>
                                {contactNumberTwo &&
                                    <span> OR <a href={`tel:${contactNumberTwo}`}>{contactNumberTwo}</a></span>
                                }
                            </Box>
                        </Box>
                    )}
                    {/*SMS*/}
                    {!hidePhone && contactNumberOne && (
                        <Box className={styles.contactBlock} sx={(theme) => ({
                            '&>a': {color: theme.palette.text.primary}
                        })}>

                            <Box className={styles.contactIcon} sx={(theme) => ({
                                '&>a': {color: theme.palette.text.primary}
                            })}>
                                <SmsIcon/>
                            </Box>
                            {!hideLabels && (
                                <div className={styles.contactHeading}>
                                    SMS
                                </div>
                            )}
                            <Box className={styles.contactContent} sx={(theme) => ({
                                '&>a': {color: theme.palette.text.primary}
                            })}>
                                <a href={`sms:${contactNumberOne}`}>{contactNumberOne}</a>
                                {contactNumberTwo &&
                                    <span> OR <a href={`sms:${contactNumberTwo}`}>{contactNumberTwo}</a></span>
                                }
                            </Box>
                        </Box>
                    )}
                    {contactEmail && (
                        <div className={styles.contactBlock}>

                            <div className={styles.contactIcon}>
                                <EmailIcon/>
                            </div>
                            {!hideLabels && (
                                <div className={styles.contactHeading}>
                                    Email
                                </div>
                            )}
                            <Box className={styles.contactContent} sx={(theme) => ({
                                '&>a': {color: theme.palette.text.primary}
                            })}>
                                <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                            </Box>
                        </div>
                    )}
                </div>
            </Box>
            <Box className={styles.contactUsContainer} py={0}>
                {!!showSocials && socialsBlock}
            </Box>
        </Box>

    )
}
export default ContactUsTiles
